module.exports = __webpack_public_path__ + "img/Bhutan.d9372f22.svg";